import { useQuery } from "@tanstack/react-query";
import { fetchConversation } from "PFCore/services/chat/fetch_conversation";
import { Conversation, QueryOptions } from "PFCore/types";

import { chatKeys } from "./query_keys";

export const useChatConversation = (id: number, options?: QueryOptions<Conversation>) =>
  useQuery({ queryKey: chatKeys.conversation(id), queryFn: () => fetchConversation(id), ...options });
